import React from 'react';
import * as R from 'ramda';
import {useTranslation} from 'react-i18next';
import dompurify from 'dompurify';
import {totalBy, toDollar, mapWithIndex} from '@/util';
import PolicyValue from '@/b2c/PlanDetail/Detail/InsurancePlanDetail/PolicyValue';

const itemList = R.map(item => (
  <tr key={item.id}>
    <td>{item.policyType}</td>
    <td>{item.productName}</td>
    <td>
      {item.policyTerm} / {item.payTerm}
    </td>
    <td>{toDollar(item.sumInsured)}</td>
    <td>{toDollar(item.modalPremium)}</td>
  </tr>
));

const itemListRwd = (currency, tr) =>
  mapWithIndex((item, idx) => (
    <li key={idx}>
      <p>{item.policyType}</p>
      <strong>{item.productName}</strong>
      <p>
        {item.policyTerm} / {item.payTerm}
      </p>
      <table>
        <tbody>
          <tr>
            <td>
              {tr('sum_insured')} ({currency})
            </td>
            <td>{toDollar(item.sumInsured)}</td>
          </tr>
          <tr>
            <th>
              {tr('modal_premium_for_insurance')} ({currency})
            </th>
            <th>{toDollar(item.modalPremium)}</th>
          </tr>
        </tbody>
      </table>
    </li>
  ));

const totalPremium = totalBy(['modalPremium']);

const InsurancePlanDetail = ({plan: {policyItems, ...plan}}) => {
  const {t: tr} = useTranslation('statements');
  return (
    <>
      <section className='plan-details'>
        {/* wide */}
        <table className='wide list text-left'>
          <tbody>
            <tr>
              <th style={{minWidth: '80px'}}>{tr('plan_type')}</th>
              <th>{tr('plan_name')}</th>
              <th>
                {tr('plan_term')} / {tr('pay_term')}
              </th>
              <th>
                {tr('sum_insured')} ({plan.currency})
              </th>
              <th>
                {tr('modal_premium_for_insurance')} ({plan.currency})
              </th>
            </tr>
            {itemList(policyItems)}
          </tbody>
        </table>

        {/* RWD */}
        <ul className='narrow list'>
          {itemListRwd(plan.currency, tr)(policyItems)}
        </ul>

        <div className='subtotal clearfix'>
          <div className='name'>
            <p>{tr('total')}</p>
          </div>
          <div className='number'>
            <p>{toDollar(totalPremium(policyItems))}</p>
          </div>
        </div>
      </section>
      <PolicyValue plan={plan} />
      {/* possible html <br/> tag issue on disclaimer area */}
      <section>
        <p
          className='desc alert alert-light'
          dangerouslySetInnerHTML={{
            __html: dompurify.sanitize(plan.lifeDisclaimer),
          }}
        />
      </section>
    </>
  );
};

export default InsurancePlanDetail;
